import {AfterViewInit, Component, Inject, OnInit, ViewChild} from '@angular/core';
import {AcDialog, DIALOG_CONFIG} from 'ac-infra';
import {NgForm} from '@angular/forms';

@AcDialog({
  title: 'Detach Peer Connection'
})
@Component({
  selector: 'pcons-detach-dialog',
  templateUrl: './pcons-detach-dialog.component.html',
  styleUrls: ['./pcons-detach-dialog.component.scss']
})
export class PconsDetachDialogComponent implements OnInit, AfterViewInit {

  data: any;

  @ViewChild('mapForm') mapForm: NgForm;

  constructor(@Inject(DIALOG_CONFIG) private dialogConfig) {
    this.data = dialogConfig.dialogData;
    this.dialogConfig.submitButtonDisabled = true;
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.mapForm.form.statusChanges.subscribe(() => {
      this.dialogConfig.submitButtonDisabled = !this.mapForm.form.valid;
    });
  }

}
